export enum Filter {
    ALL = 'all',
    PENDING_APPROVAL = 'pending_approval',
    PENDING_CONFIRMATION = 'pending_confirmation',
    DECLINED = 'declined',
    APPROVED = 'approved'
}
